import { render } from "./TsListPage.vue?vue&type=template&id=5a1b081d&scoped=true"
import script from "./TsListPage.vue?vue&type=script&lang=js"
export * from "./TsListPage.vue?vue&type=script&lang=js"

import "./TsListPage.vue?vue&type=style&index=0&id=5a1b081d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1b081d"]])

export default __exports__